export default __webpack_public_path__ + "static/media/cookiesicon.572d347e.svg";